export const uiInfoText = {
  "Count & Move To Kraal": {
    //"title": "Count and move to kraal",
    "bullets": [
      "Scan and count animals with a handheld reader",
      "A Count event is saved",
      "Select a Kraal the animals must be moved to",
      "Scan the animals with a handheld reader",
      "Once saved, the animals will be moved to the selected Kraal",
      'Tip: Use the Date and Kraal name in the Batch Reference for easier lookup in reports, example: "YYMMDD Kraal A01 Owner A"'
    ]
  }, "Count Without Save": {
    bullets: [
      "Scan and count animals with a handheld reader",
      "The event will not be saved",
      "No animals will be moved"
    ]
  }, "Head Count": {
    bullets: [
      "Scan and count animals with a handheld reader",
      "A Head Count event is saved",
      "No animals will be moved"
    ]
  }, "Auto Counter": {
    bullets: [
      "Scan and count animals with an auto counter",
      "Automated counting using Gigalot's Auto Count scanners",
      "Data is logged onto Auto Counters and later downloaded via the Field App"
    ]
  }, "Dispatch to Abattoir": {
    bullets: [
      "Scan and count animals with a handheld reader",
      "To remove animals from the Feedlot and send them to an Abattoir",
      "A Dispatch to Abattoir event is saved",
      "Warning: Make sure the correct animals are scanned. When the batch is saved the animals will be removed from the system",
      'Tip: Use a proper Batch Reference for easier lookup in reports, example: "YYMMDD Kraal A01 Owner A"'
    ]
  }, "Group Weigh": {
    bullets: [
      "Scan, count and weigh a batch of animals",
      "A Group Weigh event is saved",
      "Use this when a large batch of animals must be weighed on a group scale",
      "Scan and count animals with a handheld reader",
      "The mass is entered manually",
      "For a large batch the animals can be scanned in smaller groups",
      "The mass is entered for each group",
      "All the groups together form a complete Group Weigh batch"
    ]
  }, "Group Treatment": {
    bullets: [
      "Apply Treatments to a group of animals all at once",
      "Select the Ailment and Treatment and scan all the animals in the group",
      "You have the option to move the animals to a new Kraal. If no Kraal is selected they will stay in their original Kraals",
      "You also have the option to select an average mass to apply Treatments that are mass dependent",
      "This is the average mass per animal i.e. 250kg (not the mass of the whole group)",
      "If no mass is entered only constant mass Treatments will be displayed"
    ]
  }, "Group Vaccination": {
    bullets: [
      "Apply Vaccinations to a group of animals all at once",
      "Select the Vaccination and scan all the animals in the group",
      "You have the option to move the animals to a new Kraal. If no Kraal is selected they will stay in their original Kraals",
      "You also have the option to select an average mass to apply Vaccinations that are mass dependent",
      "This is the average mass per animal i.e. 250kg (not the mass of the whole group)",
      "If no mass is entered only constant mass Vaccinations will be displayed",
    ]
  }, "Hospital": {
    bullets: [
      "Log a Hospital (Morbidity) event",
      "Events are logged one animal at a time",
      "Option 1: Select an animal by typing the tag number",
      "Option 2: Select an animal by scanning the tag number with a handheld reader",
      "The animal mass and temperature is entered manually"
    ]
  }, "Mortality": {
    bullets: [
      "Log a Mortality event",
      "Events are logged one animal at a time",
      "Option 1: Select an animal by typing the tag number",
      "Option 2: Select an animal by scanning the tag number with a handheld reader",
      "Warning: Make sure the correct animal is selected. When the event is saved the animal will be removed from the system"
    ]
  }, "Records": {
    bullets: [
      "Show events that were logged in Field App",
      "Make sure events are uploaded regularly",
      "Connect to the internet",
      "Wait for the Cloud icon (top right corner)",
      "Go into Records and click the UPLOAD button",
      "When it shows UPLOAD(0) or Records (0) it means all events were uploaded",
      "When you click on an event like COUNT it will show all the history for that event"
    ]
  }
}

export function toKraalInfoBullet(eventName: string) {
  return `Only select a Kraal if you want the animals to be moved. If no Kraal is selected the animals will stay where they were before the ${eventName}`;
}
